// @flow
import React from 'react'
import { Button } from '@driftt/dds'
import { H1, H3, Div, P } from '@driftt/tide-core'
import ABM_ACCOUNTS_SCREEN  from './accounts-page-preview.png'
import './style.css'

const GatedAccountsPage = () => {
  return (
    <Div>
      <H1 className="accounts-gated-state--header">Accounts</H1>
      <Div className="accounts-gated-state">
        <Div className="accounts-gated-content">
          <H3>Start more conversations with Drift ABM</H3>
          <P>Drift ABM will notify your sales reps the moment one of their target accounts visits your website! You can even start the conversation on their behalf with one of our ABM playbooks.</P>
          <Div className="abm-meeting-button-container">
            <Button
              onClick={() => window.open("#abm", "self")}
            >
              Chat with us about Drift ABM
            </Button>
          </Div>
        </Div>
        <img alt="accounts screen" src={ABM_ACCOUNTS_SCREEN}/>
      </Div>
    </Div>
  )
}

export default GatedAccountsPage
